import React from "react";
import { Modal, Form, Input, Button, Spin, message, Steps } from "antd";
import { formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import { dateFormat, formatSeconds } from "$ACTIONS/util";
import { Cookie } from "$ACTIONS/helper";
import { post, get, patch } from "$ACTIONS/TlcRequest";
import { emailReg } from "$ACTIONS/reg";
import { ApiPort, APISETS } from "$ACTIONS/TLCAPI";
import { setMemberInfo } from "$DATA/userinfo";
import { otpNumReg } from "$ACTIONS/reg";
import { getAttemptVal } from "$ACTIONS/OTPUtil";
import Router from "next/router";
import ExceedVerify from "@/OTP/ExceedVerify";
import classNames from "classnames";
import { connect } from "react-redux";
import { mailConversion } from "$ACTIONS/util";
const { Item } = Form;
const { Step } = Steps;
class EmailVerify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            remainingTime: -1,
            exceedVisible: false, // otp 超過驗證次數判斷
            buttonStatus: false,
            memberInfo: JSON.parse(localStorage.getItem("memberInfo")),
        };

        this.EmailVerify = this.EmailVerify.bind(this); // 发送验证码
        this.checkUrlVerifyCode = this.checkUrlVerifyCode.bind(this); // 验证手机号
        this.startCountDown = this.startCountDown.bind(this); // 倒计时
        this.timeTimer = null; // 倒计时Timer
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.visible !== this.props.visible) {
            this.props.otpParam && this.getEmailOTPAttempts();
            Cookie.Get("emailTime") !== null && this.props.visible
                ? this.startCountDown()
                : clearInterval(this.timeTimer);
        }
    }
    componentWillUnmount() {
        clearInterval(this.timeTimer);
    }
    /**
     * 获取邮箱验证次数
     */
    getEmailOTPAttempts = () => {
        const { otpParam, kindOfVerifications } = this.props;
        console.log(
            "otpParam,kindOfVerifications:",
            otpParam,
            kindOfVerifications
        );
        if (otpParam == "memberProfile-otp" || otpParam == "login-otp") {
            let type = "ContactVerification";
            if (otpParam == "memberProfile-otp") {
                //个人资料验证
                type = "ContactVerification";
            } else if (
                otpParam == "login-otp" &&
                kindOfVerifications == "OTP"
            ) {
                //loginotp
                type = "OTP";
            } else if (
                otpParam == "login-otp" &&
                kindOfVerifications == "revalidate"
            ) {
                //loginotp 重置密码
                type = "Revalidate";
            }
            this.setState({ isLoading: true });

            get(
                ApiPort.GetOTPAttempts +
                    `&channelType=${"Email"}&serviceAction=${type}&`
            )
                .then((res) => {
                    this.setState({ isLoading: false });
                    if (res) {
                        let attempt = getAttemptVal(res);
                        if (attempt < 1) {
                            if (otpParam === "memberProfile-otp") {
                                this.props.closeModal();
                            } else if (otpParam == "login-otp") {
                                this.props.changeVerify("Email", false, false);
                            }
                            this.setState({
                                exceedVisible: true,
                            });
                        } else if (attempt) {
                            this.props.setEmailAttemptRemaining(
                                attempt
                            );
                        }
                    }
                })
                .catch((error) => {
                    console.log("获取邮箱验证次数 error:", error);
                    this.setState({ isLoading: false });
                });
        }
    };
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.checkUrlVerifyCode(values.verifyCode);
            }
        });

        if (this.props.otpParam === "login-otp") {
            Pushgtagdata("Verification", "Submit", "Verify_Email_LoginOTP");
        } else if (this.props.otpParam === "cry-otp") {
            Pushgtagdata("Verification", "Submit", "Verify_Email_cry-OTP");
        } else if (this.props.otpParam === "memberProfile-otp") {
            Pushgtagdata("Verification", "Submit", "Verify_Email_ProfilePage");
        } else {
            Pushgtagdata("Verification", "Submit", "Submit_Emailverification");
        }
    };
    startCountDown() {
        clearInterval(this.timeTimer);
        const time =
            Cookie.Get("emailTime").replace("-", "/").replace("-", "/") || -1;
        let times = 300;
        if (
            this.props.otpParam == "login-otp" ||
            this.props.otpParam == "memberProfile-otp"
        ) {
            times = 600;
        }
        let lastSeconds = parseInt(
            times - (new Date().getTime() - new Date(time).getTime()) / 1000
        );

        this.setState({ remainingTime: lastSeconds });
        if (time !== null && time !== "") {
            this.timeTimer = setInterval(() => {
                this.setState({ buttonStatus: true });
                if (lastSeconds <= 0) {
                    Cookie.Get("emailTime", null);
                    clearInterval(this.timeTimer);
                    //this.setState({ buttonStatus: false });
                    if (this.props.otpParam) {
                        this.props.form.setFieldsValue({ verifyCode: "" }); // 輸入匡改為空值
                    }
                }
                this.setState({ remainingTime: lastSeconds-- });
            }, 1000);
        } else {
            Cookie.Get("emailTime", null);
        }
    }
    EmailVerify(isResend) {
        const promiseVerification = this.props.form.validateFields([
            "emailAddress",
        ]);
        promiseVerification.then(() => {
            const { memberCode } = this.state.memberInfo;
            const emailAccount = this.state.memberInfo.isVerifiedEmail[0];
            let EmailData;
            if (
                this.props.otpParam === "login-otp" &&
                this.props.kindOfVerifications == "revalidate"
            ) {
                //OTP Reset Password
                EmailData = {
                    serviceAction: "Revalidate",
                    contact: this.props.email,
                    siteId: 37,
                };
            } else if (this.props.otpParam === "memberProfile-otp") {
                EmailData = {
                    serviceAction: "ContactVerification",
                    contact: this.state.memberInfo.isVerifiedEmail[0],
                    siteId: 37,
                };
            } else {
                EmailData = {
                    serviceAction: "ContactVerification",
                    contact: this.props.email,
                    // redirectUrl: "",
                    siteId: 37,
                };

                if (this.props.otpParam) {
                    // otp用參數
                    EmailData.serviceAction = this.props.kindOfVerifications;
                    EmailData.redirectUrl = global.location.href; //global.location.href
                }
            }

            const sendEmailCode = () => {
                this.setState({ isLoading: true });
                post(ApiPort.POSTEmailVerifyAPI, EmailData, undefined, {IS_STILL_RETURN_JSONVALUE_IF_HTTP4xx5xx:true})
                    .then((res) => {
                        this.setState({ isLoading: false });

                        if (['Http', 'Json'].every(_=>Object.prototype.hasOwnProperty.call(res||{}, _))) {
                            res = res.Json;
                        }

                        if (res?.isSuccess && res?.result?.isSent) {
                            message.success("发送成功");
                            Cookie.Create("emailTime", dateFormat(), 10);
                            this.startCountDown();
                        } else if (res?.isSuccess == false) {
                            const { description, errorCode } = res.errors[0];
                            if (this.props.otpParam == "login-otp") {
                                // logintop & 重置密码 超过请求次数
                                if (
                                    errorCode == "REVA0001" ||
                                    errorCode == "VAL18015"
                                ) {
                                    this.props.changeVerify(
                                        "Email",
                                        false,
                                        false
                                    );
                                    this.setState({ exceedVisible: true });
                                } else {
                                    message.error(
                                        description ||
                                            "发送失败，请稍后在尝试或联系客服!"
                                    );
                                }
                            } else if (
                                this.props.otpParam == "memberProfile-otp"
                            ) {
                                // 个人资料页面超过请求次数
                                if (
                                    errorCode == "REVA0001" ||
                                    errorCode == "VAL18015"
                                ) {
                                    this.props.closeModal();
                                    this.setState({ exceedVisible: true });
                                } else {
                                    message.error(
                                        description ||
                                            "发送失败请稍后在尝试或联系客服!"
                                    );
                                }
                            } else {
                                message.error(
                                    description ||
                                        "发送失败请稍后在尝试或联系客服!"
                                );
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("POSTEmailVerifyAPI" + error);
                    });
            };

            this.state.memberInfo && this.state.memberInfo.isVerifiedEmail
                ? sendEmailCode()
                : (() => {
                      this.setState({ isLoading: true });
                      setMemberInfo(
                          {
                              key: "Email",
                              value1: emailAccount,
                          },
                          (res) => {
                              if (res.isSuccess) {
                                  !this.props.otpParam &&
                                      this.props.correctMemberInfo(
                                          sendEmailCode
                                      );
                              } else {
                                  this.setState({ isLoading: false });
                                  message.error(res.message);
                              }
                          }
                      );
                  })();
        });

        if (this.props.otpParam === "login-otp") {
            Pushgtagdata(
                !isResend ? "Click" : "Login OTP",
                !isResend ? "Click" : "Request",
                !isResend ? "SendCode_Email" : "ResendCode_Email"
            );
        } else if (this.props.otpParam === "cry-otp") {
            Pushgtagdata(
                "Verification",
                "Click",
                !isResend ? "Sendcode_TTH_Crypto" : "Resendcode_TTH_Crypto"
            );
        } else if (this.props.otpParam === "memberProfile-otp") {
            Pushgtagdata(
                "Verification",
                "Click",
                !isResend
                    ? "SendCode_Email_ProfilePage"
                    : "ResendCode_Email_ProfilePage"
            );
        } else {
            Pushgtagdata(
                "Verification",
                "Click",
                !isResend
                    ? "Sendcode_Emailverification"
                    : "Resendcode_Emailverification"
            );
        }
    }
    checkUrlVerifyCode(code) {
        if (!otpNumReg.test(code))
            return global.showResultModal("格式错误", false);

        const { memberCode } = this.state.memberInfo;
        let EmailData = {
            contact: this.state.memberInfo.isVerifiedEmail[0],
            verificationCode: code,
            siteId: 37,
        };
        if (
            this.props.otpParam === "login-otp" &&
            this.props.kindOfVerifications === "revalidate"
        ) {
            //OTP Reset Password
            EmailData.serviceAction = "Revalidate";
        } else {
            EmailData.serviceAction = "ContactVerification";
            if (
                this.props.otpParam === "login-otp" &&
                this.props.kindOfVerifications === "OTP"
            ) {
                // otp用參數
                EmailData.serviceAction = "OTP";
                Pushgtagdata("Change_email_loginOTP");
            } else if (this.props.otpParam === "memberProfile-otp") {
                EmailData.serviceAction = "ContactVerification";
                EmailData.siteId = 37;
            }
        }

        this.setState({ isLoading: true });
        patch(ApiPort.POSTEmailVerifyAPI, EmailData, undefined, {IS_STILL_RETURN_JSONVALUE_IF_HTTP4xx5xx:true}).then((res) => {
            if (['Http', 'Json'].every(_=>Object.prototype.hasOwnProperty.call(res||{}, _))) {
                res = res.Json;
            }
            if (res) {
                let { result } = res;
                this.setState({ isLoading: false });

                if (this.props.otpParam) {
                    if (res.isSuccess && res.result.isVerified) {
                        global.showResultModalWithColor("验证成功", true); /* {
                            left: "5%",
                        } */
                        if (res.result.queleaReferreeStatus) {
                            this.props.GetThroughoutVerification();
                        }
                        setTimeout(() => {
                            if (this.props.isNext) {
                                this.props.correctMemberInfo();
                                this.props.nextStep();
                                this.props.visible && this.props.closeModal();
                                return;
                            }
                            if (
                                this.props.kindOfVerifications === "revalidate"
                            ) {
                                this.props.changeVerify("Email", false, false); // 關閉彈窗
                                this.props.setReadStep(4);
                            } else if (
                                this.props.otpParam === "memberProfile-otp"
                            ) {
                                this.props.closeModal();
                                this.props.correctMemberInfo();
                            } else {
                                localStorage.setItem("login-otp", true); // 驗證成功
                                this.props.changeVerify("Email", false, false); // 關閉彈窗
                                Router.push("/cn/");
                            }
                        }, 3000);

                        return;
                    } else {
                        if (res.errors && res.errors.length > 0) {
                            // According to BFFSC version, moving exceedVisible:true logic to here.
                            if (res.errors[0].errorCode === 'VAL18013') {
                            // 超過驗證次數
                            this.props.changeVerify("Email", false, false); // 關閉彈窗
                            this.setState({ exceedVisible: true });
                            return;
                            }

                            // original code
                            this.props.form.setFields({
                                verifyCode: {
                                    value: "",
                                    errors: [
                                        new Error(res.errors[0].description),
                                    ],
                                },
                            });
                            return;
                        }
                        if (result.remainingAttempt) {
                            this.props.form.setFields({
                                verifyCode: {
                                    value: "",
                                    errors: [new Error(result.message)],
                                },
                            });
                            this.props.setEmailAttemptRemaining(
                                result.remainingAttempt
                            );
                        } else {
                            /*
                            // 超過驗證次數
                            this.props.changeVerify("Email", false, false); // 關閉彈窗
                            this.setState({ exceedVisible: true });
                            return;
                            */
                        }
                    }
                } else if (!result.exception) {
                    // 非otp驗證
                    message.success("验证码验证成功！");
                    !this.props.otpParam && this.props.correctMemberInfo();
                    if (this.props.isNext) {
                        this.props.nextStep();
                        this.props.visible && this.props.closeModal();
                    } else {
                        this.props.closeModal();
                    }
                    if (res && res.result && res.result.queleaReferreeStatus) {
                        this.props.GetThroughoutVerification();
                    }
                } else {
                    message.error("验证码错误，请重新输入！" || result.message);
                }
            }
        });
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { exceedVisible, remainingTime, buttonStatus } = this.state;
        const verificationCode = getFieldValue("verifyCode");
        const email = this.props.email;
        // const email = this.props.email && this.props.email.split('@')
        // const emailFormat = email && email[0].substr(0, Math.floor(email[0].length / 2)) + '*'.repeat(Math.round(email[0].length / 2)) + '@' + email[1]

        return (
            <React.Fragment>
                <Modal
                    className="general-modal"
                    title={"邮箱验证"}
                    // style={this.props.style}
                    visible={this.props.visible}
                    width={400}
                    footer={null}
                    centered={true}
                    closable={true}
                    maskClosable={
                        this.props.otpParam == "login-otp" ? false : true
                    }
                    onCancel={() => {
                        this.props.changeVerify("Email", true, false);
                    }}
                    zIndex={1500}
                >
                    <Spin
                        spinning={this.state.isLoading}
                        tip="加载中，请稍候..."
                        style={{ backgroundColor: "initial" }}
                    >
                        {this.props.kindOfVerifications == "revalidate" && (
                            <div className="StepsBox">
                                <Steps current={0} size="small">
                                    <Step />
                                    <Step />
                                </Steps>
                            </div>
                        )}
                        <Form
                            className="verification-form-wrap"
                            {...formItemLayout}
                            onSubmit={this.handleSubmit}
                        >
                            <label
                                style={{
                                    font: "normal normal bold 14px/24px Microsoft YaHei",
                                    marginBottom: "5px",
                                    display: "block",
                                    color: "#222222",
                                }}
                            >
                                {this.props.kindOfVerifications == "OTP"
                                    ? "邮箱接收验证码"
                                    : "验证码验证"}
                            </label>
                            {this.props.otpParam == "login-otp" ? (
                                this.props.Description
                            ) : (
                                <div>
                                    为了确保您帐户的安全，请按照以下说明验证您的电子邮件。
                                </div>
                            )}
                            <div className="line-distance" />
                            <Item label="电子邮箱">
                                {getFieldDecorator("emailAddress", {
                                    initialValue: email
                                        ? mailConversion(email)
                                        : "",
                                    rules: [
                                        {
                                            required: true,
                                            message: "请输入邮箱！",
                                        },
                                        {
                                            validator: (
                                                rule,
                                                value,
                                                callback
                                            ) => {
                                                if (value && !email) {
                                                    !emailReg.test(email) &&
                                                        callback(
                                                            "邮件格式错误！"
                                                        );
                                                }
                                                callback();
                                            },
                                        },
                                    ],
                                })(
                                    <Input
                                        size="large"
                                        placeholder="输入邮箱"
                                        className="tlc-input-disabled"
                                        autoComplete="off"
                                        disabled={!!this.props.email}
                                    />
                                )}
                            </Item>
                            {
                                (this.props.otpParam == "login-otp" ||
                                    this.props.otpParam ===
                                        "memberProfile-otp") &&
                                    this.props.callCS /* 聯絡客服 */
                            }

                            <Item label="验证码">
                                {getFieldDecorator("verifyCode", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "请输入验证码！",
                                        },
                                    ],
                                    getValueFromEvent: (event) => {
                                        return event.target.value.replace(
                                            /\D/g,
                                            ""
                                        );
                                    },
                                })(
                                    <Input
                                        addonAfter={
                                            remainingTime < 0 ? (
                                                <div
                                                    onClick={() => {
                                                        this.EmailVerify();
                                                    }}
                                                >
                                                    发送
                                                </div>
                                            ) : remainingTime > 0 ? (
                                                <div style={{ color: "#FFF" }}>
                                                    重发{" "}
                                                    {formatSeconds(
                                                        remainingTime
                                                    )}
                                                </div>
                                            ) : (
                                                !remainingTime && (
                                                    <div
                                                        onClick={() => {
                                                            this.EmailVerify(
                                                                true
                                                            );
                                                        }}
                                                    >
                                                        重新发送
                                                    </div>
                                                )
                                            )
                                        }
                                        size="large"
                                        autoComplete="off"
                                        className={
                                            remainingTime > 0
                                                ? "disabled-time"
                                                : "abled-time"
                                        }
                                        placeholder="输入验证码"
                                        maxLength={6}
                                    />
                                )}
                            </Item>
                            <p className="bottom-sign">
                                {`${
                                    this.props.otpParam === "memberProfile-otp"
                                        ? `注意：如果${
                                              this.props.otpParam ? 10 : 5
                                          }分钟后仍未收到验证码，请点击“重新发送验证码”以获取新的验证码。`
                                        : `请注意: 获取新的验证码前请查看您的垃圾箱，若您在${
                                              this.props.otpParam ? 10 : 5
                                          } 分钟内尚未收到验证码，请点击”重新发送”。`
                                }`}
                            </p>
                            <div className="line-distance" />
                            {this.props.otpParam == "login-otp" ? (
                                <Item {...tailFormItemLayout}>
                                    <div className="btn-wrap otp-btn-wrap">
                                        <Button
                                            size="large"
                                            className="changeVerify"
                                            onClick={() => {
                                                this.props.changeVerify(
                                                    "Email",
                                                    true,
                                                    false
                                                );
                                                Pushgtagdata(
                                                    `Change_email_loginOTP`
                                                );
                                            }}
                                        >
                                            更换验证方式
                                        </Button>
                                        <Button
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                            className={classNames({
                                                GreenBtn:
                                                    verificationCode &&
                                                    verificationCode.length >=
                                                        6 &&
                                                    buttonStatus,
                                            })}
                                            disabled={
                                                verificationCode &&
                                                verificationCode.length >= 6 &&
                                                buttonStatus
                                                    ? false
                                                    : true
                                            }
                                        >
                                            立即验证
                                        </Button>
                                    </div>
                                </Item>
                            ) : this.props.otpParam === "memberProfile-otp" ? (
                                <Item {...tailFormItemLayout}>
                                    <div className="btn-wrap">
                                        <Button
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                            block
                                            // className={classNames({
                                            // 	GreenBtn:
                                            // 		verificationCode && verificationCode.length >= 6 && buttonStatus
                                            // })}
                                            disabled={
                                                verificationCode &&
                                                verificationCode.length >= 6 &&
                                                buttonStatus
                                                    ? false
                                                    : true
                                            }
                                        >
                                            立即验证
                                        </Button>
                                    </div>
                                </Item>
                            ) : (
                                <Item {...tailFormItemLayout}>
                                    <div className="btn-wrap">
                                        <Button
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                            block
                                        >
                                            提交
                                        </Button>
                                    </div>
                                </Item>
                            )}
                            {this.props.otpParam && (
                                <center>
                                    您还有（
                                    <span className="blue">
                                        {this.props.otpParam ===
                                            "memberProfile-otp" ||
                                        this.props.otpParam === "login-otp"
                                            ? this.props.emailattemptRemaining
                                            : this.props.attemptRemaining}
                                    </span>
                                    ）次尝试机会{" "}
                                </center>
                            )}
                        </Form>
                    </Spin>
                </Modal>

                {exceedVisible /* otp 超過次數彈窗 */ && (
                    <ExceedVerify
                        exceedVisible={exceedVisible}
                        times={this.props.times}
                        // headTitle={`超过尝试次数`}
                        headTitle={
                            this.props.otpParam == "login-otp"
                                ? `超过尝试次数`
                                : this.props.otpParam === "memberProfile-otp"
                                ? "超过尝试次数"
                                : "邮箱验证"
                        }
                        // offset={{ left: "5%" }}
                        otpParam={this.props.otpParam}
                        Description={
                            // this.props.kindOfVerifications === "revalidate" ? (
                            //     <div
                            //         className="otp-cs-tip"
                            //         style={{ textAlign: "center" }}
                            //     >
                            //         请联系
                            //         <span
                            //             className="otp-cs"
                            //             onClick={() => {
                            //                 global.PopUpLiveChat();
                            //                 Pushgtagdata(
                            //                     "CS_exceeded_revalidate"
                            //                 );
                            //                 global.globalExit();
                            //             }}
                            //         >
                            //             在线客服
                            //         </span>
                            //         以验证并更新密码。
                            //     </div>
                            // ) : this.props.otpParam === "memberProfile-otp" ? (
                            //     <div
                            //         className="otp-cs-tip"
                            //     >
                            //         您已超过5次尝试，请24小时之后再试。或联系我们的在线客服进行验证。
                            //     </div>
                            // ) : (
                            //     <div className="otp-cs-tip">
                            //         请联系
                            //         <span
                            //             className="otp-cs"
                            //             onClick={() => {
                            //                 global.PopUpLiveChat();
                            //                 Pushgtagdata(
                            //                     "CS_exceeded_loginOTP"
                            //                 );
                            //             }}
                            //         >
                            //             在线客服
                            //         </span>
                            //         以完成验证，若
                            //         已经完成验证，可点击登出再重新登录即可。
                            //     </div>
                            // )
                            <div className="otp-cs-tip-exceed">
                                请24小时之后再试或联系我们的在线客服进行验证。
                            </div>
                        }
                        btnInfo={this.props.kindOfVerifications}
                        onCancel={() => {
                            this.setState({ exceedVisible: false });
                            setTimeout(() => {
                                global.globalExit();
                                Router.push("/cn/");
                            }, 1500);
                        }}
                    />
                )}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        memberInfo: state.userCenter.memberInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create({ name: "EmailVerify" })(EmailVerify));
